<template>
  <div
    class="home tw-mx-auto tw-flex tw-flex-col tw-flex-1 tw-w-full tw-overflow-y-auto"
  >
    <PtHeader />
    <img src="@pc/assets/images/closed-widget.png" alt="closed widget icon" />
    <div class="tw-my-5 tw-text-center">{{ awayMessage }}</div>
    <QuickFormBuilder
      v-if="form && !isOutOfMessageFormSubmitted"
      id="quick-form-builder"
      :data="form"
      :submit-form-completed="submissionsStore.submitFormCompleted"
      :submit-opened-at="submissionsStore.submitQuickFormOpenedAt"
      @close="isOutOfMessageFormSubmitted = true"
    />
    <div v-if="isOutOfMessageFormSubmitted" class="tw-my-5 tw-text-center">
      {{ t('pt.widgetUnavailable.completeForm') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'

import { useUserLocale } from '@shared/utils/composables/locales'
import getLocalizedLabel from '@shared/utils/helpers/localized-label'

import PtHeader from '@pc/components/PtHeader.vue'
import RouteNames from '@pc/router/route-names'
import { useConversationsStore } from '@pc/store/conversations'
import { useFormSubmissionsStore } from '@pc/store/form-submissions'
import { useQuickFormsStore } from '@pc/store/quick-forms'
import { useSessionStore } from '@pc/store/session'

const QuickFormBuilder = defineAsyncComponent(
  () =>
    import(
      '@shared/components/quick-forms/QuickFormBuilder/QuickFormBuilder.vue'
    )
)

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const quickFormsStore = useQuickFormsStore()
const sessionStore = useSessionStore()
const submissionsStore = useFormSubmissionsStore()
const { userLocale } = useUserLocale()
const conversationsStore = useConversationsStore()

const isOutOfMessageFormSubmitted = ref(false)

const conversationId = computed(() => conversationsStore.currentConversationId)
const widget = computed(() => sessionStore.chatProps?.chatWidget)
const availability = computed(() => widget.value?.chatWidgetAvailability)
const isAvailable = computed(() => widget.value?.isAvailable)

const form = computed(() => quickFormsStore.quickForm.data)
const awayMessage = computed(() => {
  return getLocalizedLabel(availability.value?.awayMessage, userLocale.value)
    .value
})

const awayFormUuid = computed(() => availability.value?.awayFormUuid ?? '')

watch(
  isAvailable,
  (value) => {
    if (value) {
      router.push({
        name: RouteNames.home,
        query: route?.query || {},
      })
    }
  },
  { immediate: true }
)

const fetchQuickForm = () => {
  quickFormsStore.fetchQuickFormById({
    id: {
      case: 'quickFormUuid',
      value: awayFormUuid.value,
    },
    conversationId: conversationId.value || undefined,
  })
}

fetchQuickForm()
</script>

<style lang="scss" scoped>
.home {
  box-shadow: 0 7px 40px 2px rgba(148, 149, 150, 0.1);
  max-width: $max-patient-width;
}
</style>
